export * from '@primeuix/themes/aura/tabview';
export { default } from '@primeuix/themes/aura/tabview';
